import { axiosWithJWT } from '@/api/axiosWithJWT';

export const getBookingStatus = async (_) => {
  const { data } = await axiosWithJWT.get('/api/BookingStatus/GetList');
  return data;
};
